import clsx from "clsx";
import { Clock4Icon } from "lucide-react";

import { dates } from "@/lib/dates";
import { Job, JobStatus } from "@/types";

export const DaysActive = ({ job }: { job: Job }) => {
  const timeAgoForJob = dates.timeAgoForJob(job.createdAt);

  return (
    <div className="flex flex-col gap-4 py-2">
      {job.status === JobStatus.ACTIVE && (
        <div className="flex items-center gap-2">
          <div className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-100 shadow-sm">
            <Clock4Icon className="h-4 w-4 text-primary-900" />
          </div>
          <div>
            <p className="font-medium text-slate-800">
              {/* TODO: Hack to ensure 'today' and 'yesterday' are properly uppercased. */}
              {timeAgoForJob.charAt(0).toUpperCase() + timeAgoForJob.slice(1)}
            </p>
            <p className="text-sm font-medium text-slate-500">Active</p>
          </div>
        </div>
      )}
    </div>
  );
};

export const JobStats = ({
  className,
  job,
}: {
  className?: string;
  job: Job;
}) => {
  return (
    <div className={clsx("flex flex-col gap-4", className)}>
      <p className="font-semibold text-slate-800">Stats</p>
      {job.status === JobStatus.REVIEW || job.status === JobStatus.DRAFT ? (
        <p className="font-medium text-slate-400">
          Post your job to start seeing stats
        </p>
      ) : (
        <DaysActive job={job} />
      )}
    </div>
  );
};
